import { formatRupees } from "./money";

/**
 * What institutions and organisations pay a year, in words: one amount when
 * both pay the same, both otherwise; null until both prices are known.
 */
export function subscriptionPriceText(institutionPaise, organisationPaise) {
  if (!institutionPaise || !organisationPaise) return null;
  if (institutionPaise === organisationPaise) {
    return `${formatRupees(institutionPaise)} a year for institutions and organisations`;
  }
  return `${formatRupees(institutionPaise)} a year for institutions, ${formatRupees(organisationPaise)} for organisations`;
}
